(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tgc-recipe-detail-v3"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-recipe-gallery]').forEach(function(gallery){
  var track=gallery.querySelector('[data-gallery-track]');
  var slides=gallery.querySelectorAll('.tgc-recipe-v3__gallery-slide');
  var prev=gallery.querySelector('[data-gallery-prev]');
  var next=gallery.querySelector('[data-gallery-next]');
  var current=gallery.querySelector('[data-gallery-current]');
  var total=gallery.querySelector('[data-gallery-total]');
  if(!track||slides.length<2){if(prev)prev.hidden=true;if(next)next.hidden=true;if(total)total.textContent=slides.length||1;return;}
  total.textContent=slides.length;
  function getIndex(){return Math.round(track.scrollLeft/track.clientWidth);}
  function go(delta){var index=Math.max(0,Math.min(slides.length-1,getIndex()+delta));track.scrollTo({left:index*track.clientWidth,behavior:'smooth'});}
  prev.addEventListener('click',function(){go(-1);});
  next.addEventListener('click',function(){go(1);});
  track.addEventListener('scroll',function(){window.requestAnimationFrame(function(){current.textContent=getIndex()+1;});},{passive:true});
});

  } catch(e) { console.error(e); }
})();
})();
